export const AUTH_TOKEN_EXPIRATION_CODES = [
    704,
    703,
    702,
    709, // Patient MicroService
    614, // User MicroService
    802 // Assessment MicroService
]

export const NETWORK_ERROR = "Network Error"